import adminApiRoutes from '../../../routes/admin_api_routes.json'
import liteApiRoutes from '../../../routes/lite_api_routes.json'
import { handleApiError } from '../../util/parse_server_error'
import { setFetched } from '../api/actions'

export const joinCallTopic = (
  memberId,
  topicId,
  { upgradingToRoom, callType },
) => {
  const path = adminApiRoutes.admin_api_v1_topic_call_index.path
  const url = path.replace(':topic_id', topicId)
  return joinCallFactory(path, url, memberId, { upgradingToRoom, callType })
}
export const joinCallNewDirectChat = (memberId, handle, { callType }) => {
  const path = adminApiRoutes.new_dm_admin_api_v1_call_index.path
  const url = path.replace(':direct_chat_handle', handle)
  return joinCallFactory(path, url, memberId, { callType })
}

const joinCallFactory = (
  path,
  url,
  memberId = null,
  { upgradingToRoom, callType } = { upgradingToRoom: false, callType: 'audio' },
) => {
  return function (axios, dispatch) {
    const config = {
      ...(memberId
        ? {
            baseURL: getBaseURL(memberId),
          }
        : {}),
      params: upgradingToRoom
        ? {
            upgrading_to_room: upgradingToRoom,
          }
        : {},
    }
    return axios()
      .get(url, config)
      .then(
        (result) => {
          dispatch(setFetched('calls', result.data.records))
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
            uniqueKey: callType,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function leaveCall(memberId, topicId, attempts) {
  return function (axios, dispatch) {
    if (!topicId || memberId === undefined)
      return Promise.reject('missing params for leave call action')

    const path = adminApiRoutes.leave_call_admin_api_v1_topic_call_index.path
    const url = path.replace(':topic_id', topicId)
    const config = memberId
      ? {
          baseURL: getBaseURL(memberId),
        }
      : {}

    return axios()
      .post(url, {}, config)
      .then(
        (result) => {
          dispatch(setFetched('calls', result.data.records))
          return Promise.resolve(result)
        },
        (result) => {
          const timedOut =
            result?.response?.data?.error?.error_message ===
            'Timed out, please try again'
          if (!timedOut || (timedOut && attempts === 3))
            handleApiError({
              dispatch,
              result,
              path,
              uniqueKey: 'audio',
            })
          return Promise.reject(result)
        },
      )
  }
}

export function updateParticipant(
  memberId,
  topicId,
  { isConnected, isConnectedToRoom } = {},
) {
  return function (axios, dispatch) {
    if (!topicId || !memberId) return Promise.reject()

    const path =
      adminApiRoutes.update_participant_admin_api_v1_topic_call_index.path
    const url = path.replace(':topic_id', topicId)
    const data = {
      is_connected: isConnected,
      is_room_connected: isConnectedToRoom,
    }
    const config = {
      baseURL: getBaseURL(memberId),
    }

    return axios()
      .post(url, data, config)
      .then(
        (result) => {
          dispatch(setFetched('calls', result.data.records))
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

const getBaseURL = (memberId) => {
  return window.speakeasyData?.liveChatApp
    ? window.speakeasySettings.apiBase +
        liteApiRoutes.lite_api_v1_member_root.path.replace(
          ':current_member_id',
          memberId,
        )
    : adminApiRoutes.admin_api_v1_member_root.path.replace(
        ':current_member_id',
        memberId,
      )
}
